import SuggestedActionsTable from './SuggestedActionsTable.component';

export default SuggestedActionsTable;
